<template>
    <div class="trade">
        <Header title="交易中心" :show-back="true">
            <span slot="right" @click="$router.push({path:'/tradeList'})">交易记录</span>
        </Header>
        <div class="trade-pancel">
            <h2 class="trade-value">{{end_price}} <span>USDT</span> <span
                    class="rmb">≈ {{(end_price*7).toFixed(4)}} RMB</span></h2>
            <!-- 负数红色 正数绿色 -->
            <p class="trade-change" :class="{positiveTrade:proportion>0}">{{proportion}}%</p>
            <!--<div class="trade-tabs-time">
                <dl :class="{ active: timeTabs==='d'}" @click="changeTabs('d')">近一天</dl>
                <dl :class="{ active: timeTabs==='h'}" @click="changeTabs('h')">近一小时</dl>
                <dl :class="{ active: timeTabs==='w'}" @click="changeTabs('w')">近一周</dl>
            </div>-->
        </div>
        <!-- 表格 -->
        <div class="trade-chart" ref="chartWrap"></div>
        <!-- 买入卖出 -->
        <div class="content">
            <div class="trade-type">
                <button @click="changeType('buy')" :class="{ active: type==='buy'}">我要买</button>
                <button @click="changeType('sell')" :class="{ active: type==='sell',sellActive: type==='sell'}">我要卖
                </button>
                <button @click="changeType('comfirm')" :class="{ active: type==='comfirm'}">发布订单</button>
            </div>
            <!-- 发布订单 -->
            <div class="trade-comfirmList" v-if="type==='comfirm'">
                <div class="formWrap">
                    <div class="formBox">
                        <span class="title">可用:</span>
                        <div class="inputBox">
                            <input type="text" placeholder="" disabled v-model="usdt">
                            <span>USDT</span>
                        </div>
                    </div>
                    <div class="formBox">
                        <span class="title">可用:</span>
                        <div class="inputBox">
                            <input type="text" placeholder="" disabled v-model="xmi">
                            <span>XMI</span>
                        </div>
                    </div>
                </div>
                <div class="formWrap">
                    <div class="formBox">
                        <span class="title">类型:</span>
                        <div class="typeBox">
                            <span :class="listType===1 ? 'active':'' " @click="listType=1">购买</span>
                            <span :class="listType===2 ? 'activeS':'' " @click="listType=2">出售</span>
                        </div>
                    </div>
                </div>
                <div class="formWrap">
                    <div class="formBox">
                        <span class="title">价格:</span>
                        <div class="inputBox">
                            <input type="text" placeholder="请输入价格" v-model="price">
                            <span>USDT</span>
                        </div>
                    </div>
                    <div class="formBox">
                        <span class="title">数量:</span>
                        <div class="inputBox">
                            <input type="text" placeholder="请输入数量" v-model="num">
                            <span>XMI</span>
                        </div>
                    </div>
                </div>
                <p v-show="price * num" style="color: #7b8292;text-align: right;font-size: 14px;margin-bottom: 10px;">
                    ≈ {{price * num}} USDT
                </p>
                <div class="formWrap">
                    <div class="formBox" style="width: 100%;">
                        <span class="title">交易密码:</span>
                        <div class="inputBox" style="flex: 1;">
                            <input type="password" placeholder="请输入交易密码" v-model="password">
                        </div>
                    </div>
                </div>
                <button @click="toDeal">发布订单</button>
            </div>
            <!-- 买入、卖出 -->
            <div class="trade-form" v-else>
                <ul class="listWrap">
                    <van-list
                            v-model="loading"
                            :finished="finished"
                            :offset="10"
                            finished-text="没有更多了"
                            @load="onLoad">
                        <li v-for="(item,index) in listData" :key="index">
                            <div>
                                <span>{{item.user_tel}}</span>
                                <span style="color: #16cf7a;">{{item.price}}/USDT</span>
                            </div>
                            <div>
                                <span>数量：{{item.num}} XMI</span>
                            </div>
                            <div style="justify-content: flex-end">
                                <button style="background: #FF6349;margin-right: 10px;"
                                        v-if="item.ad_uid === userInfo.uid"
                                        @click="cancelEvent(item.push_id)">取消
                                </button>
                                <button v-if="type==='buy'" style="background: #1FC26D;"
                                        @click="listSubmit(item)">购买
                                </button>
                                <button v-else style="background: #FF6349;"
                                        @click="listSubmit(item)">出售
                                </button>
                            </div>
                        </li>
                    </van-list>
                </ul>
            </div>
        </div>
        <Tabbar active="trade"></Tabbar>
    </div>
</template>

<script>
    import Tabbar from "../../components/tabbar";
    import Header from "../../components/header";
    import {createChart} from 'lightweight-charts';
    import {mapState} from "vuex"

    export default {
        components: {
            Header,
            Tabbar
        },
        inject: ["reload"],
        data() {
            return {
                timeTabs: "d",
                type: "buy",
                // 图表数据
                chartData: [],
                candlestickSeries: null,
                // 最新价格
                end_price: "",
                // 比例
                proportion: "",
                // 发布订单数据
                usdt: "30000",
                xmi: "30000",
                listType: 1,
                price: "",
                num: "",
                password: "",
                // 买入卖出列表
                page: 0,
                total: null,
                loading: false,
                finished: false,
                listData: [],
            };
        },
        computed: {
            ...mapState(["userInfo"])
        },
        mounted() {
            // 初始化图表
            const chart = createChart(this.$refs.chartWrap);
            this.candlestickSeries = chart.addCandlestickSeries({
                priceFormat: {
                    type: 'volume',
                    precision: 4,
                },
            });
            // 初始获取数据
            this.getChartData();
            // 获取 total 数据
            this.ajax.post("appapi/push/pushList", {page: 1, status: 1}).then(res => {
                if (res.data.code === 1) {
                    this.total = res.data.data.total;
                }
            });
            // xmi 和 usdt 余额
            this.usdt = this.userInfo.usdt;
            this.xmi = this.userInfo.xmi;
        },
        methods: {
            // 获取表格数据
            getChartData(type = "d") {
                this.ajax.post("appapi/push/priceList", {type: type}).then(res => {
                    if (res.data.code === 1) {
                        // 格式化后台数据
                        this.chartData = [];
                        this.end_price = res.data.data.end_price;
                        this.proportion = res.data.data.proportion;
                        this.chartData = res.data.data.price_list.data.map(item => {
                            return {
                                time: item.time_int,
                                open: item.start_price,
                                high: item.hight_price,
                                low: item.low_price,
                                close: item.end_price,
                            }
                        });
                        this.candlestickSeries.setData(this.chartData);
                    }
                });
            },
            // 图表类型切换
            changeTabs(type) {
                this.timeTabs = type;
                this.getChartData(type);
            },
            // 买入卖出切换
            changeType(type) {
                this.type = type;
                this.page = 0;
                this.listData = [];
                this.finished = false;
            },
            // 发布订单
            toDeal() {
                let paypwd = this.userInfo.paypwd;
                if (!paypwd) {
                    this.$toast("暂未设置交易密码，请前往设置");
                    this.$router.push({path: "/dealPwd"});
                    return;
                }
                if (!this.price) {
                    this.$toast("请输入价格");
                    return;
                }
                if (!this.num) {
                    this.$toast("请输入数量");
                    return;
                }
                let parmes = {
                    coin: "xmi",
                    num: this.num,
                    price: this.price,
                    pay_password: this.password,
                };
                this.$dialog.confirm({
                    title: '标题',
                    message: '是否发布订单？'
                }).then(() => {
                    // 根据类别判断买入卖出
                    let url = this.listType === 1 ? "appapi/Push/buy" : "appapi/Push/sell";
                    this.ajax.post(url, parmes).then(res => {
                        if (res.data.code === 1) {
                            this.$toast(res.data.msg);
                            // 清空输入框数据
                            this.password = "";
                            this.price = "";
                            this.num = "";
                        }
                    });
                }).catch(() => {
                });
            },
            // 取消按钮事件
            cancelEvent(id) {
                this.$dialog.confirm({
                    title: '标题',
                    message: '是否取消交易？'
                }).then(() => {
                    this.ajax.post("appapi/push/cancle", {push_id: id}).then(res => {
                        if (res.data.code === 1) {
                            this.$toast(res.data.msg);
                            // 刷新列表
                            this.reload();
                        }
                    });
                }).catch(() => {
                });
            },
            // 获取买入卖出列表
            getListsData() {
                this.page++;
                let parmes = {
                    type: this.type === 'buy' ? 1 : 2,
                    coin: "xmi",
                    page: this.page,
                };
                this.ajax.post("appapi/Push/lists", parmes).then(res => {
                    if (res.data.code === 1) {
                        this.listData.push(...res.data.data.data);
                        this.total = res.data.data.total;
                        // 加载状态结束
                        this.loading = false;
                        // 数据全部加载完成
                        if (this.listData.length >= this.total) {
                            console.log("加载完成");
                            this.finished = true;
                        }
                    }
                });
            },
            onLoad() {
                setTimeout(() => {
                    this.getListsData();
                }, 500);
            },
            // 交易列表 购买 出售按钮
            listSubmit(item) {
                let title;
                switch (this.type) {
                    case "buy":
                        title = `您将花费${item.all_num}个USDT`;
                        break;
                    case "sell":
                        title = `您将获得${item.all_num}个USDT`;
                        break;
                }
                this.$dialog.confirm({
                    title: title,
                    message: '是否确认交易？'
                }).then(() => {
                    this.ajax.post("appapi/push/exchange", {push_id: item.push_id}).then(res => {
                        if (res.data.code === 1) {
                            this.$toast(res.data.msg);
                            // 刷新列表
                            this.reload();
                        }
                    });
                }).catch(() => {
                });
            }
        }
    };
</script>

<style lang="scss">
    .trade {
        padding-bottom: 120px;

        &-pancel {
            padding: 0 40px 27px 30px;
            background: rgba(255, 255, 255, 1);
            box-shadow: 0 8px 10px 0 rgba(243, 243, 243, 0.5);
        }

        &-value {
            color: #16cf7a;
            font-size: 50px;
            font-weight: bold;

            span {
                font-size: 40px;
            }

            .rmb {
                font-size: 35px;
                color: #777777;
            }
        }

        &-change {
            color: #ff3052;
            font-size: 24px;
            font-weight: bold;
            margin: 20px 0 40px;
        }

        .positiveTrade {
            color: #16cf7a;
        }

        &-tabs-time {
            @include flex();

            dl {
                flex: 1;
                background: #f2f2f2;
                height: 48px;
                line-height: 48px;
                text-align: center;
                color: #777777;
                font-size: 24px;

                &.active {
                    color: #fff;
                    background: #16cf7a;
                    font-weight: bold;
                }
            }
        }

        &-chart {
            height: 482px;
            width: 100%;
        }

        .content {
            padding: 0 35px;
            background: #fff;
            font-size: 28px;
        }

        &-type {
            @include flex($main: space-between);
            margin-bottom: 38px;
            border-radius: 4px;

            button {
                width: 210px;
                height: 72px;
                border-radius: 4px;
                line-height: 72px;
                font-size: 28px;
                background: #f2f2f2;
                position: relative;

                &.active {
                    color: #fff;
                    background: rgba(31, 194, 109, 1);
                }

                &.sellActive {
                    color: #fff;
                    background: #ff5b5b;
                }

                .sign {
                    position: absolute;
                    background: #ff5b5b;
                    width: 46px;
                    height: 46px;
                    right: -23px;
                    top: -23px;
                    border-radius: 50%;
                    text-align: center;
                    line-height: 46px;
                    font-size: 31px;
                    color: #fff;
                }
            }
        }

        &-form {
            .item {
                @include flex();
                margin-bottom: 17px;

                dt {
                    min-width: 150px;
                    line-height: 86px;
                    font-size: 30px;
                    color: #333;
                    font-weight: bold;
                }

                dd {
                    flex: 1;
                    height: 86px;
                    display: flex;
                    line-height: 86px;
                    background: #f8f8f8;
                    border-radius: 10px;
                    color: #c0c5d0;
                    font-size: 26px;
                    padding: 0 25px;
                    align-items: center;

                    input {
                        flex: 1;
                    }

                    .line {
                        width: 1px;
                        height: 48px;
                        border-right: 1px solid #e0e0e0;
                        margin-right: 30px;
                    }

                    .unit {
                        color: #7b8292;
                        font-size: 28px;
                    }
                }
            }

            .text {
                text-align: right;
                width: 100%;
                color: #7b8292;
                font-weight: bold;
                margin-bottom: 26px;

                span {
                    color: #1fc26d;
                }
            }

            .listWrap {
                li {
                    padding: 40px 50px 34px;
                    background: #fff;
                    box-shadow: 0 10px 29px 0 rgba(226, 226, 226, 0.5);
                    border-radius: 20px;

                    div {
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        margin-bottom: 30px;

                        &:last-child {
                            margin-bottom: 0;
                        }

                        span {
                            font-size: 28px;
                            font-weight: 500;
                            color: rgba(51, 51, 51, 1);
                            line-height: 20px;
                        }

                        button {
                            width: 153px;
                            height: 50px;
                            font-size: 24px;
                            font-weight: bold;
                            color: #fff;
                            box-shadow: 0 1px 15px 0 rgba(131, 131, 131, 0.2);
                            border-radius: 25px;
                        }
                    }
                }
            }
        }

        &-comfirmList {
            .formWrap {
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-bottom: 25px;

                .formBox {
                    display: flex;
                    align-items: center;

                    .title {
                        display: inline-block;
                        font-size: 28px;
                        font-weight: bold;
                        color: #333333;
                        line-height: 20px;
                        margin-right: 15px;
                    }

                    .inputBox {
                        position: relative;
                        width: 243px;

                        input {
                            width: 100%;
                            height: 65px;
                            background: rgba(248, 248, 248, 1);
                            border-radius: 10px;
                            padding-left: 20px;
                            font-size: 18px;
                            color: #1FC26D;

                            &:disabled {
                                color: #1FC26D;
                                opacity: 1;
                            }
                        }

                        span {
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            width: 94px;
                            height: 28px;
                            position: absolute;
                            right: 0;
                            border-left: 1px solid #E0E0E0;
                            top: 50%;
                            transform: translateY(-50%);
                            color: #7b8292;
                            background: rgba(248, 248, 248, 1);
                        }
                    }
                }

                .typeBox {
                    display: flex;
                    align-items: center;

                    span {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        width: 171px;
                        height: 61px;
                        margin-right: 10px;
                        font-size: 24px;
                        border-radius: 5px;
                        color: #777777;
                        background: #F2F2F2;
                    }

                    .active {
                        color: #ffffff;
                        background: #1FC26D;
                    }

                    .activeS {
                        color: #ffffff;
                        background: #FF6349;
                    }
                }
            }

            button {
                width: 100%;
                height: 86px;
                border-radius: 10px;
                font-size: 30px;
                font-weight: bold;
                color: #fff;
                background: rgba(31, 194, 109, 1);
            }
        }

        .pwdInput {
            display: block;
            width: 80%;
            margin: 10px auto;
            background: transparent;
        }
    }
</style>
